<!-- eslint-disable max-len -->
<template>
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.72451 6.22353C5.47446 6.47358 5.33398 6.81272 5.33398 7.16634V9.83301C5.33398 10.1866 5.47446 10.5258 5.72451 10.7758C5.97456 11.0259 6.3137 11.1663 6.66732 11.1663H25.334C25.6876 11.1663 26.0267 11.0259 26.2768 10.7758C26.5268 10.5258 26.6673 10.1866 26.6673 9.83301V7.16634C26.6673 6.81272 26.5268 6.47358 26.2768 6.22353C26.0267 5.97348 25.6876 5.83301 25.334 5.83301H6.66732C6.3137 5.83301 5.97456 5.97348 5.72451 6.22353Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.72451 16.8902C5.47446 17.1402 5.33398 17.4794 5.33398 17.833V25.833C5.33398 26.1866 5.47446 26.5258 5.72451 26.7758C5.97456 27.0259 6.3137 27.1663 6.66732 27.1663H14.6673C15.0209 27.1663 15.3601 27.0259 15.6101 26.7758C15.8602 26.5258 16.0007 26.1866 16.0007 25.833V17.833C16.0007 17.4794 15.8602 17.1402 15.6101 16.8902C15.3601 16.6402 15.0209 16.4997 14.6673 16.4997H6.66732C6.3137 16.4997 5.97456 16.6402 5.72451 16.8902Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.7245 16.8902C21.4745 17.1402 21.334 17.4794 21.334 17.833V25.833C21.334 26.1866 21.4745 26.5258 21.7245 26.7758C21.9746 27.0259 22.3137 27.1663 22.6673 27.1663H25.334C25.6876 27.1663 26.0267 27.0259 26.2768 26.7758C26.5268 26.5258 26.6673 26.1866 26.6673 25.833V17.833C26.6673 17.4794 26.5268 17.1402 26.2768 16.8902C26.0267 16.6402 25.6876 16.4997 25.334 16.4997H22.6673C22.3137 16.4997 21.9746 16.6402 21.7245 16.8902Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
